import { render, staticRenderFns } from "./PriceCalculatorForm.vue?vue&type=template&id=1b88bd56&"
import script from "./PriceCalculatorForm.vue?vue&type=script&lang=js&"
export * from "./PriceCalculatorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports